<template>
  <div class="modal is-active">
    <div class="modal-background" />
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">
          Add New User
        </p>
        <button
          class="delete"
          @click="$emit('closeModal')"
        />
      </header>
      <section class="modal-card-body frow gutters">
        <div class="col-sm-1-1">
          <div class="field">
            <label
              class="label"
              for="email"
            >
              User Email
            </label>
            <input
              id="email"
              v-model="email"
              class="input"
              name="email"
              type="email"
            >
          </div>
        </div>
        <div class="col-sm-1-2">
          <div class="field">
            <label
              class="label"
              for="password"
            >
              Password
            </label>
            <input
              id="password"
              v-model="password"
              class="input"
              name="password"
              type="password"
            >
          </div>
        </div>
        <div class="col-sm-1-2">
          <div class="field">
            <label
              class="label"
              for="passwordConfirm"
            >
              Confirm Password
            </label>
            <input
              id="passwordConfirm"
              v-model="passwordConfirm"
              class="input"
              name="passwordConfirm"
              type="password"
            >
          </div>
        </div>
      </section>
      <footer class="modal-card-foot">
        <button
          v-if="canCreate"
          :class="{'is-loading': loading}"
          class="button is-success"
          @click="createUser"
        >
          Create User
        </button>
        <button
          class="button"
          @click="$emit('closeModal')"
        >
          Cancel
        </button>
      </footer>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'NewUserModal',
  data() {
    return {
      email: '',
      password: '',
      passwordConfirm: '',
      loading: false,
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.profile.user,
      jwt: (state) => state.profile.jwt,
    }),
    API() {
      return this.$API;
    },
    canCreate() {
      return (
        this.email != ''
        && this.password !== ''
        && this.password === this.passwordConfirm
      );
    },
  },
  methods: {
    createUser() {
      this.loading = true;
      const method = 'POST';
      const url = `${this.$API}/auth/local/register`;
      this.axios({
        method,
        headers: {
          Authorization: `Bearer ${this.jwt}`,
        },
        data: {
          email: this.email,
          username: this.email,
          password: this.password,
        },
        url,
      })
        .then((response) => {
          this.loading = false;
          if (response.status === 200) {
            this.$emit('closeModal');
            this.$snotify.success(`${this.email} saved`,'Success');
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$snotify.error(err, 'Creating new user failed', {
            timeout: 10000,
            showProgressBar: false,
          });
          console.log(err);
        });
    },
  },
};
</script>
<style lang="scss" scoped>
</style>
